<script lang="ts" setup>
import { computed, provide } from "vue";
import { storeToRefs } from "pinia";
import { usePipStore } from "@/store/pip.store";
import { VUETIFY_DEFAULTS_KEY } from "@/constants/pip";

const pipStore = usePipStore();
const { pipContainer, content } = storeToRefs(pipStore);

const pipDefaults = computed(() => ({ global: { attach: pipContainer.value ?? undefined } }));

// pass it into Vuetify lib
provide(VUETIFY_DEFAULTS_KEY, pipDefaults);
</script>

<template>
  <teleport v-if="pipContainer && content" :to="pipContainer">
    <component :is="content.component" v-bind="content.props" v-on="content.on ?? {}" />
  </teleport>
</template>

<style lang="scss">
.pip-layout {
  height: 100vh;
  overflow: hidden;
}

.pip-root {
  height: 100vh;
  overflow-y: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
